import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-O",
  "use": "icon-O-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-O\">\n<path d=\"M36.8241 31.384L19.7361 48.52C19.0161 49.24 19.0161 50.344 19.7361 51.016C20.0721 51.352 20.5041 51.544 20.9361 51.544C21.3681 51.544 21.8481 51.352 22.1841 51.016L39.3201 33.88C41.4801 31.72 41.4801 28.168 39.3201 26.008L21.9921 8.728C21.3201 8.056 20.2161 8.056 19.5441 8.728C18.8721 9.4 18.8721 10.504 19.5441 11.176L36.8241 28.456C37.6401 29.272 37.6401 30.616 36.8241 31.384Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol